import { FormTitleBox, LoadingSkeleton } from '../../common';
import { useExternalPayment } from './hooks/useExternalPayment';
import PaymentProviderSelector from './components/PaymentProviderSelector';
import XnetAnalyzer from './components/XnetAnalyzer';
import ErrorDialog from './components/ErrorDialog';
import ApiResponseDialog from './components/ApiResponseDialog';
import CouponsVerificationDialog from './components/CouponsVerificationDialog';
import ProcessResultsDialog from './components/ProcessResultsDialog';
import XnetAnalysisDialog from './components/XnetAnalysisDialog';
import { PAYMENT_PROVIDERS } from './constants/externalPaymentConstants';

const ExternalPaymentTable = () => {
  const {
    // Estados
    selectedFile,
    apiResponse,
    verificationData,
    lastLineData,
    processResults,
    paymentProvider,

    // Estados para análisis XNET
    selectedAnalysisFile,
    analysisResults,
    showAnalysisDialog,

    // Estados de UI
    openErrorDialog,
    isDialogOpen,
    showResultsDialog,
    loading,

    // Handlers
    handleFileUpload,
    handleVerify,
    handleConfirmPayment,
    handleCloseError,
    handleCloseApiResponse,
    handleCloseVerification,
    handleCloseResults,
    setPaymentProvider,

    // Handlers para análisis XNET
    handleAnalysisFileUpload,
    handleAnalyzeXnet,
    handleCloseAnalysis,
    handleGenerateXnetFile,

    // Refs
    fileInputRef,
    analysisFileInputRef,
  } = useExternalPayment();

  if (loading) {
    return <LoadingSkeleton />;
  }

  return (
    <>
      <FormTitleBox title="Habitat 99 | Registrar | Cobros externos" />

      <PaymentProviderSelector
        value={paymentProvider}
        onChange={setPaymentProvider}
        providers={PAYMENT_PROVIDERS}
        selectedFile={selectedFile}
        onFileUpload={handleFileUpload}
        fileInputRef={fileInputRef}
        handleVerify={handleVerify}
      />

      <FormTitleBox title="Analizar archivo XNET (SOLO USAR SI FALLA ALGO EN LA FACTURACIÓN ARRIBA)" sx={{ mt: 2 }} />

      <XnetAnalyzer
        selectedFile={selectedAnalysisFile}
        onFileUpload={handleAnalysisFileUpload}
        onAnalyze={handleAnalyzeXnet}
        fileInputRef={analysisFileInputRef}
      />

      <ErrorDialog open={openErrorDialog} onClose={handleCloseError} />

      <ApiResponseDialog
        open={!!apiResponse}
        response={apiResponse}
        onClose={handleCloseApiResponse}
      />

      <CouponsVerificationDialog
        open={isDialogOpen}
        onClose={handleCloseVerification}
        coupons={verificationData || []}
        lastLineData={lastLineData || {}}
        onConfirm={handleConfirmPayment}
      />

      <ProcessResultsDialog
        open={showResultsDialog}
        onClose={handleCloseResults}
        data={processResults}
      />

      <XnetAnalysisDialog
        open={showAnalysisDialog}
        analysisData={analysisResults}
        onClose={handleCloseAnalysis}
        onGenerateXnetFile={handleGenerateXnetFile}
      />
    </>
  );
};

export default ExternalPaymentTable;
